import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useNavigate } from "react-router-dom";
import { faArrowLeft, faPlus } from "@fortawesome/free-solid-svg-icons";
import {toast} from "react-toastify";
import CustomToastContainer from "../components/CustomToastContainer";
import { getAllFeedbacks } from "../apiServices/apiServices";
import ItemFeedback from "../components/ItemFeedback";

const AllFeedbacks = () => {
  const navigate = useNavigate();
  const user = JSON.parse(window.localStorage.getItem("user"));
  const [data, setData] = useState([])

  useEffect(() => {
    const fetchFeedbacks = async () => {
      try {
        const response = await getAllFeedbacks(user.id);
        console.log("Response:", response);
        if (response && response.success) {
          setData(response.data?.complaint || []);
        } else {
          toast.error(response.message || 'Failed to fetch feedbacks');
        }
      } catch (error) {
        console.error('Error:', error);
        toast.error('An error occurred. Please try again.');
      }
    };
    fetchFeedbacks();
  }, []);

  const handleNavigation = (path) => {
    navigate(path);
  };

  return (
    <>
        <div className="w-full h-screen bg-gray-100">
            <nav className="flex items-center justify-between p-2 sm:p-4 bg-white shadow-md">
                <button className="text-gray-600 items-center" onClick={() => handleNavigation(-1)}>
                    <FontAwesomeIcon icon={faArrowLeft} size="lg" />
                </button>
                <div className="flex items-center justify-center flex-grow gap-2">
                    <h1 className="text-gray-600 font-semibold text-lg">
                    My Feedbacks
                    </h1>
                </div>
                <button className="text-gray-600 items-center" onClick={() => navigate('/feedback')}>
                    <FontAwesomeIcon icon={faPlus} size="lg" />
                </button>
            </nav>       

            <div className="overflow-y-auto flex-grow w-full">
                {data && data.map((item) => (
                    <div  key={item.id}>
                        <ItemFeedback data={item}/>
                    </div>
                ))}
            </div>
        </div>
        <CustomToastContainer/>
    </>
  );
};

export default AllFeedbacks;
